<template>
    <div>
        <Dialog v-model:visible="visible" :style="{ width: '450px' }" header="Pool Details" :modal="true" @hide="$emit('hide-dialog', true)">
            <div class="surface-section">
                <ul class="list-none p-0 m-0 surface-container">
                    <li class="py-3 px-2 border-top-1 surface-border">
                        <div class="text-500 w-6 md:w-2 font-medium">Name</div>
                        <div class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">{{ pool.name }}</div>
                    </li>
                    <li class="py-3 px-2 border-top-1 surface-border">
                        <div class="text-500 w-6 md:w-2 font-medium">Description</div>
                        <div class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">{{ pool.description }}</div>
                    </li>
                    <li class="py-3 px-2 border-top-1 surface-border">
                        <div class="text-500 w-6 md:w-2 font-medium">Companies</div>
                        <div class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">
                            <div v-if="!pool.companies.length" class="font-italic">No Companies in the pool</div>
                            <div v-for="company in pool.companies" :key="company.id">
                                <Tag class="mr-2" :value="company.name" :rounded="true" />
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </Dialog>
    </div>
</template>

<script setup>
import { ref } from 'vue';
import { storeToRefs } from 'pinia';
import { usePoolStore } from '../store';
const { pool } = storeToRefs(usePoolStore());
const visible = ref(true);
</script>

<style scoped>
.surface-section > .surface-container {
    overflow-y: auto;
}
li {
    display: flex;
    flex-direction: row;
}
li > div {
    display: flex;
    justify-content: left;
    align-items: center;
}
li > div:nth-child(odd) {
    width: 30% !important;
}
li > div:nth-child(even) {
    width: 70% !important;
}
</style>
